@if (value(); as value) {
  <div
    class="relative flex grow shadow-sm rounded-lg border border-solid border-light"
  >
    <button
      class="absolute -right-2 -top-2 p-0.5 border border-normal border-solid leading-3 bg-white rounded-full z-10"
      (click)="remove()"
    >
      <ion-icon
        name="close-outline"
        class="text-xl text-normal cursor-pointer"
      ></ion-icon>
    </button>
    <app-pdf-viewer class="grow" [value]="value" />
  </div>
} @else {
  <div class="grow">
    <label
      [htmlFor]="htmlFor()"
      class="flex items-center justify-start px-4 w-full h-[4.125rem] rounded-lg border border-solid border-light cursor-pointer transition-colors gap-2 {{
        disabled() ? 'opacity-50' : 'hover:bg-gray-50 active:bg-gray-200'
      }} shadow-sm"
    >
      <ion-icon
        name="add-outline"
        [size]="'large'"
        class="text-normal"
      ></ion-icon>
      <span class="text-muted text-sm"
        >{{ 'Select PDF file' | locale }} ({{ 'max' | locale }}
        {{ maxFileSizeMb() }}MB)</span
      >
    </label>
    <input
      type="file"
      class="hidden"
      [id]="htmlFor()"
      [multiple]="true"
      (change)="addMedia($event)"
      [accept]="supportedMimeTypesString()"
      [disabled]="disabled()"
    />
  </div>
}
